import { FormikValues } from 'formik';

import { customTypeRenderer } from '../../../components/renderers';
import { FormElementProps, FormSlowCustomField } from '../../../types';

// use generics
const SlowCustomInput = (props: FormElementProps<FormSlowCustomField>) => {
  const { field } = props;

  return customTypeRenderer({
    fieldName: field.name,
    Component: field.Component,
    field,
  });
};

export default SlowCustomInput;
